import React from "react";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";
import _ from "underscore";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {getImageBySizeFromCDN} from "../../common/utils";
import config from "../../../config";
import ReactHtmlParser from "react-html-parser";

const CollectionTiles = ({home_details, mobile_medium, mobile_small}) => {

    const homeslide = {
        dots: true,
        infinite: true,
        lazyLoad: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dotsClass: "slick-dots--custom",
        customPaging: (index) => {
            return (
                <Button
                    variant="clean"
                    className="custom-slick-dot"
                    aria-label={`Slide Page ${index + 1}`}
                >
                    <span
                        className="custom-slick-dot__inner"
                    />
                </Button>
            );
        }
    };
    const homepage_holiday_promo_active = config.homepage_holiday_promo && config.homepage_holiday_promo.is_active;
    const homepage_holiday_promo_title = config.homepage_holiday_promo && config.homepage_holiday_promo.title;
    const homepage_holiday_promo_desktop_img_url = config.homepage_holiday_promo && config.homepage_holiday_promo.desktop_image_url;
    const homepage_holiday_promo_mobile_img_url = config.homepage_holiday_promo && config.homepage_holiday_promo.mobile_image_url;
    const homepage_holiday_promo_href = config.homepage_holiday_promo && config.homepage_holiday_promo.href;

    return (
        <div>
            {!homepage_holiday_promo_active ?
                <>
                    {mobile_medium ?
                        <Slider {...homeslide} className="collection-container-carousel">
                            {
                                _.map(home_details.collections, (collection, idx) => {
                                    return (
                                        <RenderCollections
                                            key={idx}
                                            collection={collection}
                                            idx={idx}
                                        />
                                    )
                                })
                            }
                        </Slider>
                        :
                        <div className="collection-container">
                            <CardGroup>
                                {
                                    _.map(home_details.collections, (collection, idx) => {
                                        return (
                                            <RenderCollections
                                                key={idx}
                                                collection={collection}
                                                idx={idx}
                                            />
                                        )
                                    })
                                }
                            </CardGroup>
                        </div>
                    }
                </>
                :
                <div className="collection-container collection-container--holiday-promo">
                    <a href={homepage_holiday_promo_href}>
                        <span className="img-container">
                        {mobile_small
                            ?
                            <LazyLoadImage
                                className="card-img"
                                alt={homepage_holiday_promo_title}
                                title={homepage_holiday_promo_title}
                                src={getImageBySizeFromCDN(homepage_holiday_promo_mobile_img_url, "f=auto,q=90,w=375")}
                                srcSet={`${getImageBySizeFromCDN(homepage_holiday_promo_mobile_img_url, "f=auto,q=90,w=375")} 375w,
                                        ${getImageBySizeFromCDN(homepage_holiday_promo_mobile_img_url, "f=auto,q=90,w=544")} 544w,
                                        ${getImageBySizeFromCDN(homepage_holiday_promo_mobile_img_url, "f=auto,q=90,w=750")} 750w,
                                        ${getImageBySizeFromCDN(homepage_holiday_promo_mobile_img_url, "f=auto,q=90,w=1088")} 1088w`}
                                sizes="(max-width: 375px) 375px,
                                (max-width: 544px) 544px,
                                375px"
                                width="375"
                                height="258"
                            />
                            :
                            <LazyLoadImage
                                className="card-img"
                                alt={homepage_holiday_promo_title}
                                title={homepage_holiday_promo_title}
                                src={getImageBySizeFromCDN(homepage_holiday_promo_desktop_img_url, "f=auto,q=90,w=1200")}
                                srcSet={`${getImageBySizeFromCDN(homepage_holiday_promo_desktop_img_url, "f=auto,q=90,w=768")} 768w,
                                        ${getImageBySizeFromCDN(homepage_holiday_promo_desktop_img_url, "f=auto,q=90,w=992")} 992w,
                                        ${getImageBySizeFromCDN(homepage_holiday_promo_desktop_img_url, "f=auto,q=90,w=1200")} 1200w,
                                        ${getImageBySizeFromCDN(homepage_holiday_promo_desktop_img_url, "f=auto,q=90,w=2400")} 2400w`}
                                sizes="(max-width: 768px) 768px,
                                (max-width: 992px) 992px,
                                1200px"
                                width="1200"
                                height="200"
                            />
                        }
                        </span>
                    </a>
                </div>
            }
        </div>
    )
}
const RenderCollections = ({ collection, idx }) => {
    return (
        <Card className={`coll-per homepage__collection-tile-${idx + 1}`}>
            <a href={`${collection.url}`}>
                <span className="img-container">
                    <LazyLoadImage
                        className="card-img"
                        alt=""
                        src={getImageBySizeFromCDN(collection.image, "f=auto,q=90,w=433")}
                        srcSet={`${getImageBySizeFromCDN(collection.image, "f=auto,q=90,w=433")} 433px,
                            ${getImageBySizeFromCDN(collection.image, "f=auto,q=90,w=530")} 530w,
                            ${getImageBySizeFromCDN(collection.image, "f=auto,q=90,w=750")} 750w,
                            ${getImageBySizeFromCDN(collection.image, "f=auto,q=90,w=1840")} 1840w`}
                        sizes="(max-width: 433px) 375px,
                    (max-width: 544px) 530px,
                    (max-width: 768px) 697px,
                    433px"
                        width="433"
                        height="234"
                    />
                </span>
                <Card.Title as="div">{collection.title}</Card.Title>
                <Card.Subtitle as="p">{ReactHtmlParser(collection.sub_copy)}</Card.Subtitle>
            </a>
        </Card>
    )
}

export default CollectionTiles;